/**
 * vertexGroupOptions — helpers for building `SelectOption[]` from
 * a `VertexGroup[]` list.
 *
 * Five+ call sites (ModifiersPanel × 4, MaterialPanel, GravityMenu) all
 * wrote the same one-liner: `groups.map(g => ({ value: g.id, label: g.name }))`.
 * This exports the shape once so every caller stays in sync.
 */

import type { VertexGroup } from "./types.ts";

export interface VertexGroupOption {
  value: string;
  label: string;
}

/**
 * Map a vertex-group list to dropdown options. Accepts a nullish list for
 * convenience: callers with `obj?.vertexGroups` can pass it directly and
 * get an empty array back.
 */
export function toVertexGroupOptions(
  groups: readonly VertexGroup[] | null | undefined,
): VertexGroupOption[] {
  if (!groups) return [];
  return groups.map((g) => ({ value: g.id, label: g.name }));
}
